import { Avatar, Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import MyButton from "./Button";
import { COLORS } from "../constants/Colors";
import Typography from "./Typography";

const ConfirmCard = (props) => {
  const { title, description, textButton, onConfirm = () => {} } = props;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        borderRadius: "8px",
        backgroundColor: "white",
        padding: "24px",
        justifyContent: "center",
        maxWidth: "350px",
      }}
    >
      <div className="d-flex flex-column justify-content-center text-center">
        <div className="pt-3">
          <Avatar
            style={{ backgroundColor: COLORS.Success }}
            size={64}
            icon={<CheckOutlined />}
          />
        </div>
        <Typography className="py-5" size="36px">
          {title}
        </Typography>
        <Typography className="pb-5 px-1" size="12px">
          {description}
        </Typography>
        <MyButton isPrimary onClick={onConfirm}>
          {textButton}
        </MyButton>
      </div>
    </div>
  );
};

export default ConfirmCard;
